module.exports = __webpack_public_path__ + "img/xuqiuguangchang6.775d5dff.png";